import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, withTheme } from '@glu/theming';
import get from 'lodash/get';

/* istanbul ignore next */
const styles = {
  '@keyframes rotator': {
    '100%': {
      transform: 'rotate(360deg)'
    }
  },

  '@keyframes dash': {
    '0%': {
      strokeDasharray: '1,200',
      strokeDashoffset: 0
    },
    '50%': {
      strokeDasharray: '100,200',
      strokeDashoffset: -15
    },
    '100%': {
      strokeDasharray: '100,200',
      strokeDashoffset: -120
    }
  },

  spinner: {
    animation: '$rotator 1.4s linear infinite'
  },
  path: {
    stroke: 'currentColor',
    strokeDasharray: '80px, 200px',
    strokeDashoffset: 0,
    animation: '$dash 1.4s ease-in-out infinite'
  }
};

export function SpinnerComponent({ classes, color: colorOverride, size, theme, thickness }) {
  const color = colorOverride || get(theme, 'button.primary.backgroundColor') || '#0074BD';
  return (
    <div
      className={classes.spinner}
      role="progressbar"
      style={{ color, height: size, width: size }}
    >
      <svg
        role="presentation"
        aria-label="loading"
        viewBox="0 0 50 50"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>loading</title>
        <g>
          <circle
            className={classes.path}
            fill="none"
            strokeWidth={thickness}
            strokeLinecap="round"
            cx="25"
            cy="25"
            r="20"
          />
        </g>
      </svg>
    </div>
  );
}

SpinnerComponent.propTypes = {
  classes: PropTypes.shape({}),
  color: PropTypes.string,
  theme: PropTypes.shape({}),
  thickness: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8]),
  size: PropTypes.string
};

SpinnerComponent.defaultProps = {
  classes: {},
  color: null,
  theme: {},
  thickness: 4,
  size: '50px'
};

// Exporting only styled component to use before theme is loaded in the Bootstrap component.
export const StyledSpinnerComponent = withStyles(styles)(SpinnerComponent);
export default withTheme(StyledSpinnerComponent);
